// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import LoadingOverlay from "@insite/mobius/LoadingOverlay/LoadingOverlay";
import { xClearLoadingOverlay } from "@rugby/App/Handlers/XngLoadingOverlay/XngLoadingOverlay";
import { xLoadingOverlayState } from "@rugby/App/Store/Reducers";
import React, { FC, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState & xLoadingOverlayState) => {
    return {
        isErrorModalOpen: state.context.isErrorModalOpen,
        pages: state.data.pages,
        xLoadingOverlay: state.xLoadingOverlay,
        isSigningIn: state.context.isSigningIn || state.pages.signIn.isSigningInAsGuest,
    };
};

const mapDispatchToProps = {
    xClearLoadingOverlay,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const XngLoadingOverlay: FC<Props> = ({
    isErrorModalOpen,
    pages,
    xLoadingOverlay,
    xClearLoadingOverlay,
    isSigningIn,
}) => {
    // To close LoadingOverlay when the page redirect to another path
    useEffect(() => {
        xClearLoadingOverlay({});
    }, [pages.location]);

    // To close LoadingOverlay when ErrorModal open
    useEffect(() => {
        if (isErrorModalOpen) {
            xClearLoadingOverlay({});
        }
    }, [isErrorModalOpen]);

    const showLoading = isSigningIn || xLoadingOverlay.spinnersId?.length > 0;
    return (
        <>
            {showLoading && (
                <LoadingOverlay
                    loading={showLoading}
                    css={css`
                        width: 100%;
                        position: fixed;
                        height: 100%;
                        z-index: 1330;
                        top: 0;
                        bottom: 0;
                    `}
                />
            )}
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(XngLoadingOverlay);
